import { initializeNeuroGuide } from '@ignitesales/neuro-application';
import App from '../../../../../_themes/renasantOnlineTheme/src/shared/js/App';
import AppLoading from '../../../../../_themes/renasantOnlineTheme/src/shared/js/AppLoading';
import messages from '../i18n/messages.mjs';
import renasantLoginReducer from '../../../../../_themes/renasantOnlineTheme/src/shared/js/reducers/renasantLoginReducer';

const init = async () => {
  await initializeNeuroGuide ({
    AppComponent: App,
    AppLoadingComponent: AppLoading,
    messages: messages,
    reducers: [ renasantLoginReducer ],
    guideConfig: {},
  });
};

init();
